var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 64H64C28.656 64 0 92.656 0 128V384C0 419.344 28.656 448 64 448H448C483.344 448 512 419.344 512 384V128C512 92.656 483.344 64 448 64ZM342.656 234.781L478.125 118.687C479.063 121.687 480 124.687 480 128V384C480 386.219 479.156 388.188 478.719 390.281L342.656 234.781ZM448 96C450.125 96 452 96.813 454 97.219L256 266.938L58 97.219C60 96.813 61.875 96 64 96H448ZM33.266 390.25C32.828 388.156 32 386.219 32 384V128C32 124.687 32.953 121.687 33.891 118.687L169.313 234.75L33.266 390.25ZM64 416C60.766 416 57.828 415.062 54.875 414.156L193.625 255.593L245.594 300.124C248.578 302.719 252.297 304 256 304C259.703 304 263.422 302.719 266.406 300.125L318.375 255.594L457.125 414.157C454.188 415.062 451.25 416 448 416H64Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.7a4b5778aecfb9beac5badca283df45f.svg";
export { ForwardRef as ReactComponent };